import { ApiResponse } from "../api";
import { apiQueryAdapter } from "../apiQueryAdapter";

export interface EmployeeNotificationPreference {
  source: string;
  emailEnabled: boolean;
  inappEnabled: boolean;
}

class EmployeeNotificationPreferencesService {
  private static instance: EmployeeNotificationPreferencesService;
  private constructor() {}
  static getInstance(): EmployeeNotificationPreferencesService {
    if (!EmployeeNotificationPreferencesService.instance) {
      EmployeeNotificationPreferencesService.instance = new EmployeeNotificationPreferencesService();
    }
    return EmployeeNotificationPreferencesService.instance;
  }

  public getPreferences = async (
    email: string
  ): Promise<ApiResponse<EmployeeNotificationPreference[]>> => {
    return await apiQueryAdapter.query(`/emp-notifications/preferences/email/${encodeURIComponent(email)}`, "GET");
  };

  public updatePreference = async (
    email: string,
    preference: EmployeeNotificationPreference
  ): Promise<ApiResponse<any>> => {
    return await apiQueryAdapter.query(`/emp-notifications/preferences/email/${encodeURIComponent(email)}`, "PUT", { body: preference });
  };
}

export default EmployeeNotificationPreferencesService;

